export { default } from './AdaptiveHeading.js';
